<template lang="pug">
  v-autocomplete(
    v-model="inputValue"
    :label="label"
    :items="filteredRoles"
    item-text="description"
    item-value="slug"
    v-bind="$attrs"
    v-on="$listeners"
  )
</template>

<script>
import userService from '@/services/API/user';
import  checkRole  from '@/lib/checkRole';
import { ROLES } from '@/constants';
import { mapGetters } from 'vuex';

export default {
  props: {
    value: { type: [Number, String], required:false, default: null },
    label: { type: String, default: 'Роль' },
    selectable: { type:Array, required: false, default: () => [] },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    ...mapGetters({
      'userRoles':'auth/userRole',
    }),
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },

    filteredRoles() {
      if (this.selectable.length) return  this.items.filter(({ slug }) => this.selectable.includes(slug));

      if (checkRole(this.userRoles, ROLES.admin)) return this.items;
      if (checkRole(this.userRoles, ROLES.support)) return this.items.filter(({ name }) => name !== ROLES.admin);
      if (checkRole(this.userRoles, ROLES.region)) {
        return this.items.filter(({ name }) => !(name === ROLES.admin || name === ROLES.support));
      }
      if (checkRole(this.userRoles, ROLES.municipality)) return [];

      return this.items;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loadItems();
    },
    loadItems() {
      userService.roles().then((response) => {
        this.items = response.data.data;
      });
    },
  },
};
</script>
